import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./features/auth/AuthContext";
import { AuthPage } from "./features/auth/AuthPage";
import { UpdatePasswordPage } from "./features/auth/UpdatePasswordPage";
import { AppShell } from "./components/AppShell";
import { ProfilePage } from "./features/profile/ProfilePage";
import { CreatePage } from "./features/create/CreatePage";
import { LibraryPage } from "./features/create/LibraryPage";
import { AccountPage } from "./features/billing/AccountPage";
import { useI18n } from "./i18n";

export function App() {
  const { session, loading, passwordRecovery } = useAuth();
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted">
        {t("loading")}
      </div>
    );
  }

  if (passwordRecovery) return <UpdatePasswordPage />;

  if (!session) return <AuthPage />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<CreatePage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
